<template>
<div>
    <div class="mcc-page-header mu-d-flex">
        <section class="mu-d-flex mu-w-100 mu-justify-content-between mu-align-items-center">
            <div class="mu-d-flex  mu-align-items-center">
                <h1 class="mu-mb-00">Categories</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </div>
            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                <button class="mcc-button mcc-button--outline" v-if="showTopDown" id="topDownBtn" @click="convertToTopDown()" title="Top down">
                    <mcc-icon name="tree_structure" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Top down</span>
                </button>
                <button class="mcc-button mcc-button--outline" v-if="showLeftRight" id="leftRightBtn" @click="convertToLeftRight()" title="Left right">
                    <mcc-icon name="tree_structure" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Left right</span>
                </button>
                <button class="mcc-button mcc-button--success" id="addCategory" @click="addCategory()" title="Add category">
                    <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add category</span>
                </button>
                <button class="mcc-button mcc-button--primary" id="editCategory" :key="editButtonKey" @click="editCategory()" title="Edit category">
                    <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Edit category</span>
                </button>
                <button class="mcc-button mcc-button--soft-danger" v-if="showDelete" @click="checkIfCategoryCanbeDeleted()" title="Delete" id="deleteCategoryBtn">
                    <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                </button>
            </div>
        </section>        
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>Categories</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">

            <div style="position:relative">
                <div v-if="!updateCategoryCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <div class="mcc-card">
                            <div class="mcc-card__body" id="chartCardBody">
                                <div id="categoryChart"></div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" ref="addEditCategoryDialog" id="addEditCategoryDialog">
            <form id="addEditCategoryDialogForm" novalidate @submit.prevent="saveCategory()">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4" id="category-dialog-title">Add category</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeCategory()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                        <label for="categoryName" class="mfc-label--required">Name</label>
                                        <input type="text" name="name" id="categoryName" required="true" maxlength="50" ref="name" :value="categoryEditObject.name" @input="updateName($event)" :pattern="nameRegex">

                                    </div>
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="categoryDescription">Description</label>
                                        <textarea id="categoryDescription" name="description" rows="4" maxlength="100" :value="categoryEditObject.description" @input="descriptionChanged($event)" ref="description" :pattern="descRegex" character-count="100"></textarea>
                                        <div class="mfc-invalid-feedback"></div>
                                        <div class="mfc-help-text mu-mt-00">
                                            
                                            <span>You have {{100 - categoryEditObject.description.length}} characters remaining</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeCategory()">Close</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" id="deleteCategoryDialog" ref="deleteCategoryDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete category</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteCategoryDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to delete this category?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteCategoryDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDeleteConfDialogClose()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" ref="deleteInActiveProcessWarningDialog" id="deleteInActiveProcessWarningDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete category</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteInActiveProcessWarningDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Category is associated with disabled / suspended process(es). Are you sure you want to delete this category?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteInActiveProcessWarningDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDeleteInActiveProcessWarning()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mc-dialog--xs" id="updateActiveProcessWarningDialog" ref="updateActiveProcessWarningDialogRef">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Update category</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.updateActiveProcessWarningDialogRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Category is associated with disabled / suspended process(es). Are you sure you want to rename this category?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.updateActiveProcessWarningDialogRef.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--warning" @click="handleUpdateDialogClose()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import CategoryAPI from "../../../services/CategoryAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';
export default {
    name: "CategoryEdit",
    data() {
        return {
            processCategory: {
                description:""

            },
            categoryEditObject: {
                description: ""
            },
            helpText: constantMessages.BREADCRUMB_HELP["design.categories.edit"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            currentNode: '',
            showDelete: false,
            hierarchyData: '',
            showTopDown: true,
            showLeftRight: false,
            currentHierPosition: 'l2r',
            editButtonKey: 0,
            updateCall: true,
            updateCategoryCall: true,
            isValid: true
        }

    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.loadCategoriesData();
    },
    methods: {
        descriptionChanged(e)
        {
            this.categoryEditObject.description = e.target.value
            this.$forceUpdate()
        },
        loadCategoriesData() {
            let self = this;
            $('#categoryChart').html('');
            self.updateCategoryCall = false;
            CategoryAPI.gerProcessCategoriesData().then(responseData => {
                self.updateCategoryCall = true;
                if (responseData && responseData.error == false && responseData.data != null) {
                    self.hierarchyData = responseData.data;
                    self.renderCategoriesChart();
                } else if (responseData && responseData.message) {
                    self.showTopDown = false;
                    self.showLeftRight = false;
                    EventBus.$emit('warning-notification', {
                        "msg": constantMessages.MESSAGES[responseData.message]
                    });
                }
            });
        },
        renderCategoriesChart() {
            let self = this;
            $('#categoryChart').orgchart({
                'data': self.hierarchyData,
                'pan': false,
                'nodeContent': 'description',
                'zoom': false,
                'draggable': true,
                'toggleSiblingsResp': false,
                'direction': self.currentHierPosition,
                'createNode': function ($node) {
                    let secondMenuIcon = $('<i>', {
                        click: function () {
                            $(this).parent().find('.user-list').toggle();
                        }
                    });
                    $node.append(secondMenuIcon);
                }
            }).on(
                'click',
                '.node',
                function () {
                    self.currentNode = $(this)[0].id;
                    let hasChild = $(this).parent().attr('colspan') > 0 ? true :
                        false;
                    if (!hasChild && self.hierarchyData.id != parseInt(self.currentNode)) {
                        self.showDelete = true;
                    } else {
                        self.showDelete = false;
                    }
                    self.processCategory.id = self.currentNode;
                    self.processCategory.name = $(this).find('.title').text();
                    self.processCategory.description = $(this).find('.content').text();
                    let parentValue = $(this).attr("data-parent");
                    if (parentValue != undefined) {
                        self.processCategory.parent = {
                            "id": parentValue
                        };
                    }
                    self.fillEditObject();

                    self.editButtonKey += 1;

                }).on('click', '.orgchart', function (event) {
                if (!$(event.target).closest('.node').length) {
                    $('#' + self.hierarchyData.id).addClass('focused');
                    self.currentNode = self.hierarchyData.id;
                    self.processCategory.name = self.hierarchyData.name;
                    self.processCategory.description = self.hierarchyData.description;
                    self.editButtonKey += 1;
                    self.fillEditObject();
                }
            }).children('.orgchart').on('nodedropped.orgchart', function (event) {
                self.updateParent(event);
            });

            $('#' + self.hierarchyData.id).addClass('focused');
            self.currentNode = self.hierarchyData.id;
            self.processCategory.id = self.currentNode;
            self.processCategory.name = self.hierarchyData.name;
            self.processCategory.description = self.hierarchyData.description;
            self.fillEditObject();
            self.editButtonKey += 1;
            self.showDelete = false;

            if (self.currentHierPosition == "l2r") {
                $("#categoryChart").css("height", $(".orgchart").outerWidth());
            } else {
                $("#categoryChart").css("height", 'auto');
            }

        },
        updateParent(event) {
            let self = this;
            self.processCategory.name = event.draggedNode.children('.title').text();
            self.processCategory.description = event.draggedNode.children('.content').text();
            self.processCategory.id = event.draggedNode[0].id;
            self.processCategory.parent = {
                "id": event.dropZone[0].id
            };
            self.fillEditObject();
            self.saveCategory();
        },
        fillEditObject() {
            let self = this;
            self.categoryEditObject = Object.assign({}, self.processCategory);
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else if (!event.target.value.match(self.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else {
                displayErrorMessage($(self.$refs.name), "")
                self.$refs.name.classList.remove("ms-is-invalid")
                self.isValid = true
            }
            self.categoryEditObject.name = event.target.value;
        },
        addCategory() {
            let self = this;
            self.categoryEditObject = {};
            self.editButtonKey += 1;
            self.$refs.name.value = "";
            self.$refs.description.value = "";
            self.processCategory.name = "";
            self.processCategory.description = "";
            self.categoryEditObject.description = self.processCategory.description
            displayErrorMessage($(self.$refs.name), "")
            $("#categoryName").removeAttr("disabled");
            self.resetFormFields(true);
            $("#category-dialog-title").text("Add category");
            $("#addEditCategoryDialog")[0].show();

        },
        editCategory() {
            $("#category-dialog-title").text("Edit category");
            this.resetFormFields(false);
            displayErrorMessage($(this.$refs.name), "")
            this.categoryEditObject.name = this.processCategory.name
            this.categoryEditObject.description = this.processCategory.description
            $("#addEditCategoryDialog")[0].show();
            if (this.$refs.name.value == 'Home') {
                $("#categoryName").attr("disabled", true);
            } else {
                $("#categoryName").removeAttr("disabled");
            }
        },
        resetFormFields(fromAdd) {
            let self = this;
            self.$refs.name.classList.remove("ms-is-invalid")
            self.$refs.description.classList.remove("ms-is-invalid")

            if (!fromAdd) {
                self.$refs.name.value = self.processCategory.name;
                self.$refs.description.value = self.processCategory.description;
                self.categoryEditObject = Object.assign({}, self.processCategory);
            }
        },
        closeCategory() {
            let self = this;
            let form = $('#addEditCategoryDialogForm')
            self.$refs.name.value = null;
            self.$refs.description.value = null;
            form[0].classList.remove("ms-was-validated");
            self.$refs.name.classList.remove("ms-is-invalid")
            self.$refs.addEditCategoryDialog.close()
        },
        saveCategory() {
            let self = this;
            let form = $('#addEditCategoryDialogForm')
            if (this.categoryEditObject.description ) {
                if(!checkFormAndTextareaValidations('categoryDescription',this.descRegex,form))
                {
                    return;
                }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }       
            
            if ($(self.$refs.name).val() == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid");
                return;
            }
            let isEdit = false;
            if (self.categoryEditObject.id != null) {
                isEdit = true;
            }
            if (isEdit) {
                self.updateCall = false;
                CategoryAPI.checkforProcessCriterias(self.categoryEditObject).then(response => {
                    self.updateCall = true;
                    if (response != null) {
                        if (response.error && response.message != "") {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.message]
                            });
                        } else {
                            if (response.data.isRename) {
                                if (response.data.isActiveProcess) {
                                    displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["message.category.update.error"])
                                    self.$refs.name.classList.add("ms-is-invalid")
                                    return;

                                } else if (response.data.isInactiveProcess) {
                                    $("#addEditCategoryDialog")[0].close();
                                    $("#updateActiveProcessWarningDialog")[0].show();
                                } else {
                                    self.performSave();
                                }
                            } else {
                                self.performSave();
                            }
                        }
                    }
                });
            } else {
                self.performSave();
            }
        },
        performSave() {
            let self = this;
            let isEdit = false;

            if (self.categoryEditObject.id != null) {
                isEdit = true;
            } else {
                if (self.currentNode != '') {
                    self.categoryEditObject.parent = {
                        "id": self.currentNode
                    };
                }
            }
            self.updateCall = false;
            CategoryAPI.saveCategory(self.categoryEditObject, isEdit).then(response => {

                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")

                        } else {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    $("#addEditCategoryDialog")[0].close();
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.processCategory = {};
                    let categories = response.data;
                    if (categories != null) {
                        EventBus.$emit("updateCategoriesDrilldown", categories);
                    }

                    setTimeout(() => {
                        self.loadCategoriesData();
                    }, 0);

                }
            });
        },
        deleteCategory() {
            let self = this;
            self.updateCategoryCall = false;
            CategoryAPI.deleteCategory(self.processCategory.id).then(response => {
                self.updateCategoryCall = true;
                if (response != null && response.error == false) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    let categories = response.data;
                    if (categories != null) {
                        EventBus.$emit("updateCategoriesDrilldown", categories);
                    }
                    self.loadCategoriesData();
                }
            });
        },
        checkIfCategoryCanbeDeleted() {
            let self = this;
            CategoryAPI.checkforProcessCriterias(self.processCategory).then(response => {
                if (response != null) {
                    if (response.error && response.message != "") {
                        EventBus.$emit('error-notification', {
                            "msg": constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        if (response.data.isActiveProcess) {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES["message.category.remove.error"]
                            });
                        } else if (response.data.isInactiveProcess) {
                            $("#deleteInActiveProcessWarningDialog")[0].show();
                        } else {
                            $("#deleteCategoryDialog")[0].show();
                        }
                    }
                }
            });
        },
        handleDeleteConfDialogClose() {

            this.$refs.deleteCategoryDialog.close()
            this.deleteCategory()

        },
        handleDeleteInActiveProcessWarning() {
            this.$refs.deleteInActiveProcessWarningDialog.close()
            this.deleteCategory()

        },
        handleUpdateDialogClose() {

            self.performSave();

        },
        convertToTopDown() {
            this.showTopDown = false;
            this.showLeftRight = true;
            $('#categoryChart').html('');
            this.currentHierPosition = "t2b";
            this.renderCategoriesChart();
        },
        convertToLeftRight() {
            this.showLeftRight = false;
            this.showTopDown = true;
            $('#categoryChart').html('');
            this.currentHierPosition = "l2r";
            this.renderCategoriesChart();
        },
        isIEBrowser() {
            let sAgent = window.navigator.userAgent;
            let Idx = sAgent.indexOf("MSIE");
            let verNum = 0;
            if (Idx > 0)
                verNum = parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
            else if (!!navigator.userAgent.match(/Trident\/7\./)) verNum = 11;
            else verNum = 0;

            let edge = sAgent.indexOf("Edge/");
            if (edge > 0) {
                return true;
            }

            if (verNum > 0) {
                return true;
            }
        },
    }
}
</script>

<style>
#topDownBtn .mcc-button__label,
#leftRightBtn .mcc-button__label,
#addCategory .mcc-button__label,
#editCategory .mcc-button__label {
    width: max-content !important;
}
</style>
